import * as React from 'react';
import { observer } from 'mobx-react';
import { Container } from '@mui/material';
import CompanyLogo from './CompanyLogo';
import Footer from './Footer';
import Header from './Header';

const NotAccess = observer(({ onlyContent = false }) => {
  if (onlyContent) {
    return (
      <div>
        <div>
          <h2>Access Denied</h2>
          <p>You do not have permission to group for this application.</p>
        </div>
      </div>
    );
  }

  return (
    <Container maxWidth={'lg'}>
      <CompanyLogo />
      <Container
        sx={{
          boxShadow: 0,
          backgroundColor: 'white',
          borderRadius: 6,
          p: 3,
          border: '2px solid #ff5f1f',
        }}
        maxWidth={'md'}
      >
        <Header />
        <div>
          <h2>Access Denied</h2>
          <p>You do not have permission to group for this application.</p>
        </div>
      </Container>
      <Footer />
    </Container>
  );
});

export default NotAccess;
